const INITIAL_STATE = {
  data: {},
  errors: {},
};
const getWorkOrderTypeDescription = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case "GET_WORK_ORDER_TYPE_DESCRIPTION_SUCCESSFULLY":
    return { ...INITIAL_STATE, data: action.data };
  case "GET_WORK_ORDER_TYPE_DESCRIPTION_FAILED":
    return { ...INITIAL_STATE, errors: action.data };
  default:
    return { ...state };
  }
};

export default getWorkOrderTypeDescription;
    